import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL as BASE_URL } from '@/environments/environment';

export interface WishlistItemOption {
  attributeDefinitionId?: string;
  attributeDefinitionName?: string;
  attributeValueId?: string;
  attributeValueName?: string;
}

export interface WishlistItemApiModel {
  id: string;
  productId: string;
  productSlug: string;
  variantId: string;
  sellerId: string;
  sellerName: string;
  sellerSlug: string;
  sellerLogoUrl: string;
  productName: string;
  thumbnailUrl: string;
  variantSku: string;
  regularPrice: number;
  regularPriceCurrency: string;
  salePrice: number | null;
  salePriceCurrency: string | null;
  isOnSale: boolean;
  isPublished: boolean;
  isAvailable: boolean;
  availableQuantity: number;
  reviewCount: number;
  averageReview: number;
  estimatedShippingDays: number;
  options: WishlistItemOption[];
}

export interface WishlistApiModel {
  id: string;
  updatedAtUtc: string;
  items: WishlistItemApiModel[];
}

@Injectable({ providedIn: 'root' })
export class WishlistService {
  private http = inject(HttpClient);
  private apiUrl = `${BASE_URL}/api/v1/wishlist`;

  getWishlist(): Observable<WishlistApiModel> {
    return this.http.get<WishlistApiModel>(this.apiUrl);
  }

  removeWishlistItem(wishlistItemId: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/items/${wishlistItemId}`);
  }
}
